import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  BaseComponent,
  CsvParams,
  CsvService,
  FormatPipe,
  SearchResult,
  SnackbarService,
  SnackbarType,
  UserActionService,
} from 'src/app/shared';
import { ConfigurationService } from '../../services/configuration.service';
import { InpageAliasService } from '../../services/inpage-alias.service';
import { Session } from '../../services/session.service';
import { UserRoleService } from '../../services/user-role.service';
import { WorkScheduleService } from '../../services/workschedule.service';
import { PtoInfoDetails } from '../../models/ptoInfoDetails';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { TranslationPipe } from '../../pipes/translation.pipe';
import { TitleCasePipe } from '@angular/common';
import { Aliases } from '../../models/aliases';

@Component({
    selector: 'app-pto',
    providers: [TranslationPipe, FormatPipe, TitleCasePipe],
    template: `
    <div class="tw-w-full tw-flex tw-flex-wrap">
      <app-value
        [label]="(employeeAlias | aliasTransform) + (' PTO as reported on' | translation: translationRequest)"
        [value]="reportedDate | format : 'date'"
        layout="row"
        class="tw-w-full"
        [translationLabelNeeded]="false"
        [translationNeeded]="false"
      ></app-value>
    
      <app-value
        [label]="'PTO days reported' | translation: translationRequest"
        [value]="daysReported"
        layout="row"
        class="tw-w-full"
        [translationLabelNeeded]="false"
        [translationNeeded]="false"
      ></app-value>

      <app-value  
        [label]="'PTO time available' | translation: translationRequest"
        [value]="availablePTO"
        layout="row"
        class="tw-w-full tw-pb-2"
        [translationLabelNeeded]="false"
        [translationNeeded]="false"
      ></app-value>
    
      <app-action-row class="tw-w-full">
        <div left1>
          @if (IsUpdatePto) {
            <app-button
              emphasis="High"
              icon="open_in_new"
              (click)="openEditPto(editPto)"
              left1
              [label]="'Update PTO'"
              ></app-button
              >
            }
        </div>
        <div right1 class="tw-pr-2">
          <app-toast icon="info" type="Info" 
            >            {{'It may take the' | translation: translationRequest}}
            {{ examinerLabel | aliasTransform:'none' }}
            {{ 'up to 24 hours to update the information.' | translation: translationRequest }}
          </app-toast>
        </div>
      </app-action-row>
      <!-- <div
        class="tw-w-full  app-pt2 tw-flex tw-justify-between tw-flex-wrap tw-gap-1"
        >
        <app-button
          emphasis="High"
          icon="open_in_new"
          (click)="openEditPto(editPto)"
          >Update PTO</app-button
        >
        <app-toast icon="info" type="Info"
          >It may take the examiner up to 24 hours to update the information.
        </app-toast>
      </div> -->

      <app-list
        [dataSource]="Ptos?.ptoInformation"
        [template]="row"
        [paginatorEnabled]="false"
        [exportEnabled]="true"
        [exportButtonAriaLabel]="'Export and download these PTO records as a XLSX file'"
        [fixScrollOverflowHeight]="'210px'"
        overflowHeight="190px"
        (export)="_exportData()"
        class="tw-w-full app-pr1 app-pb2"
        [noDataIcon]="'date_range'"
        [noDataMessage]="'No paid time off information available'"
        [tableAriaLabel]="'Paid time off'"
      >
        <ng-container header>
          <tr class="tw-flex tw-flex-wrap tw-w-full">
            <app-list-header
              name="ptoeffective"
              [label]="'pto effective'"
              class="tw-w-[11%]"
            ></app-list-header>
            <app-list-header
              name="ptoexpire"
              [label]="'pto expire'"
              class="tw-w-[11%]"
            ></app-list-header>
            <app-list-header
              name="paycyclestartdate"
              [label]="'pay cycle start date'"
              class="tw-w-[11%]"
            ></app-list-header>
            <app-list-header
              name="paycycleenddate"
              [label]="'pay cycle end date'"
              class="tw-w-[11%]"
            ></app-list-header>
            <app-list-header
              name="initialbalance"
              [label]="'initial balance'"
              class="tw-w-[11%]"
            ></app-list-header>
            <app-list-header
              name="wpptoapplied"
              [label]="'wp pto applied'"
              class="tw-w-[11%]"
            ></app-list-header>
            <app-list-header
              name="unpaidptoapplied"
              [label]="'unpaid pto applied'"
              class="tw-w-[11%]"
            ></app-list-header>
            <app-list-header
              name="ptobalance"
              [label]="'pto balance'"
              class="tw-w-[11%]"
            ></app-list-header>
            <app-list-header
              name="ptotype"
              [label]="'pto type'"
              class="tw-w-[11%]"
            ></app-list-header>
          </tr>
        </ng-container>
        <ng-template #row let-element>
          <tr class="tw-flex tw-flex-wrap tw-w-full tw-items-center">
            <td class="tw-w-full md:tw-w-[11%]">
              <app-value
                [tabindex]="0"
                label="PTO EFFECTIVE"
                layout="row-xs"
                [value]="element.ptoEffective | format:'date'"
                [translationNeeded]="false"
              >
              </app-value>
            </td>
            <td class="tw-w-full md:tw-w-[11%]">
              <app-value
                [tabindex]="0"
                label="PTO EXPIRE"
                layout="row-xs"
                [value]="element.ptoExpire |  format:'date'"
                [translationNeeded]="false"
              >
              </app-value>
            </td>
            <td class="tw-w-full md:tw-w-[11%]">
              <app-value
                [tabindex]="0"
                label="PAY CYCLE START DATE"
                layout="row-xs"
                [value]="element.periodStart | format:'date'"
                [translationNeeded]="false"
              >
              </app-value>
            </td>
            <td class="tw-w-full md:tw-w-[11%]">
              <app-value
                [tabindex]="0"
                label="PAY CYCLE END DATE"
                layout="row-xs"
                [value]="element.periodEnd | format:'date'"
                 [translationNeeded]="false"
              >
              </app-value>
            </td>
            <td class="tw-w-full md:tw-w-[11%]">
              <app-value
                [tabindex]="0"
                label="INITIAL BALANCE"
                layout="row-xs"
                [value]="element.initialBalance"
                [translationNeeded]="false"
              >
              </app-value>
            </td>
            <td class="tw-w-full md:tw-w-[11%]">
              <app-value
                [tabindex]="0"
                class="tw-w-full md:tw-w-[11%]"
                label="WP PTO APPLIED"
                layout="row-xs"
                [value]="element.wpPtoApplied"
                [translationNeeded]="false"
              >
              </app-value>
            </td>
            <td class="tw-w-full md:tw-w-[11%]">
              <app-value
                [tabindex]="0"
                label="UNPAID PTO APPLIED"
                layout="row-xs"
                [translationNeeded]="false"
                [value]="element.unpaidPtoApplied"
              >
              </app-value>
            </td>
            <td class="tw-w-full md:tw-w-[11%]">
              <app-value
                [tabindex]="0"
                label="PTO BALANCE"
                layout="row-xs"
                [translationNeeded]="false"
                [value]="element.ptoBalance"
              >
              </app-value>
            </td>
            <td class="tw-w-full md:tw-w-[11%]">
              <app-value
                [tabindex]="0"
                label="PTO TYPE"
                layout="row-xs"
                [value]="element.ptoType"
                [translationLabelNeeded]="false"
                [translationNeeded]="false"
              >
              </app-value>
            </td>
          </tr>
        </ng-template>
      </app-list>

      <ng-template #editPto>
        <app-dialog-container
          [label]="'Submit PTO Update'"
          [headerLevel]="2"
          [headerId]="'submitPTO'"
          aria-labelledby="'submitPTO'"
        >
          <form
            class="tw-max-w-md tw-flex tw-flex-wrap"
            [formGroup]="formGroup"
          >
            <div class="tw-w-full app-header-3 tw-py-2">
              {{convertMultiLanguage('Paid Time Off (PTO)')}}
            </div>
            @if (isDisplaySuccess) {
              <div class="tw-w-full tw-py-2">
                <app-toast type="Success">
                {{ 'Thank you for your update. A note will be sent to the' | translation: translationRequest }}
                  {{ examinerLabel | aliasTransform:'none' }}
                  {{ 'who will execute the change in our claims system. The' | translation: translationRequest }}
                  {{ examinerLabel | aliasTransform:'none' }} 
                  {{ 'will contact you as needed for additional information.' | translation: translationRequest }}
                </app-toast>
              </div>
            }
            <div class="tw-w-[70%] tw-pr-4">
              {{'How many available days would you like to use? The number of PTO days that you provide will help us determine your payment amount; therefore, it is important that you provide us with an accurate number of PTO days you have available.' | translation: translationRequest}}
            </div>
            <div class="tw-w-[30%]">
              <app-text-control
                formControlName="days"
                [formGroup]="formGroup"
                [label]="'PTO Days'"
                ngDefaultControl
                mask="90"
                class="tw-w-full"
              ></app-text-control>
            </div>
            <div class="tw-w-full tw-pb-4"></div>
            <app-action-row class="tw-w-full">
              <app-button emphasis="High" right2 (click)="submitPto()"
                >{{convertMultiLanguage('Submit')}}</app-button
              >
              <app-button
                emphasis="Low"
                right1
                matDialogClose
                (click)="closePTO()"
                >{{convertMultiLanguage('Close')}}</app-button
              >
            </app-action-row>
          </form>
        </app-dialog-container>
      </ng-template>
    </div>
  `,
  styles: [``],
  standalone: false
})
export class PtoComponent extends BaseComponent implements OnInit {
  @Input()
  claim: SearchResult;


  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'ClaimSummary',
    subGroup: 'ClaimSummary',
  });

  editPtoDialog: MatDialogRef<any, any>;
  Ptos: PtoInfoDetails;
  IsUpdatePto: boolean = false;
  isDisplaySuccess: boolean = false;
  availablePTO: string = '0';
  daysReported: string = '0';
  examinerLabel: Aliases;
  employeeAlias: Aliases;
  reportedDate: string;
  formGroup = this.fb.group({
    days: [null, [Validators.required, Validators.min(1), Validators.max(99)]],
  });

  constructor(
    public dialog: MatDialog,
    public fb: FormBuilder,
    public session: Session,
    public userRole: UserRoleService,
    public configurationService: ConfigurationService,
    public userAction: UserActionService,
    public inpageAliasService: InpageAliasService,
    private snackBarService: SnackbarService,
    private csvService: CsvService,
    private wsService: WorkScheduleService,
    private translationPipe : TranslationPipe,
    private formatPipe  :FormatPipe,
    private titlePipe : TitleCasePipe
  ) {
    super();
  }

  async ngOnInit() {
    this.IsUpdatePto =
      this.claim.userOwns &&
      this.configurationService.getFeatureAccess('updatepto');

    this.examinerLabel = await this.inpageAliasService.replaceAliases(
      'examinerSingular',
      this.configurationService.GetConfig.configFeatures.aliases
    );

    this.employeeAlias = await this.inpageAliasService.replaceAliases(
      'employeePlural',
      this.configurationService.GetConfig.configFeatures.aliases
    );
    this.reportedDate = this.claim.dateReported;
    const contNum = this.session.user.contNum;
    const empUnum = this.claim.empUnum;
    this.Ptos = await this.wsService.getPto(
      contNum,
      empUnum,
      this.claim.lob,
      this.claim.claimId,
      this.claim.source
    );
    //console.log(this.Ptos);
    this.daysReported = this.Ptos.ptoDaysReported;
    if (
      this.Ptos &&
      this.Ptos.ptoInformation &&
      this.Ptos.ptoInformation.length > 0
    ) {
      this.availablePTO =
        this.Ptos.ptoInformation[this.Ptos.ptoInformation.length - 1]
          .ptoBalance == null
          ? '0'
          : this.Ptos.ptoInformation[this.Ptos.ptoInformation.length - 1]
              .ptoBalance;
    }
    this.session.loadUser();

    this.subs.sink = this.formGroup.controls.days.valueChanges.subscribe(
      (day) => {
        if (day == '') {
          this.formGroup.controls.days.setErrors({
            customMsg: 'Required',
          });
        } else if (Number(day) > 99 || Number(day) < 1) {
          this.formGroup.controls.days.setErrors({
            customMsg: this.translationPipe.transform('Value must be between 1 - 99',this.translationRequest),
          });
        } else {
          this.formGroup.controls.days.setErrors(null);
        }
      }
    );
  }

  openEditPto(templateRef: TemplateRef<any>) {
    this.editPtoDialog = this.dialog.open(templateRef);
  }

  convertMultiLanguage(key:string){

    if(this.translationRequest.language == 'en')
    {
      return key;
    }

    let translatedItem = this.translationPipe.transform(key,this.translationRequest);
    
    if(translatedItem == null || translatedItem == key ){
      translatedItem = this.translationPipe.transform(key.toLowerCase(),this.translationRequest);
    }

    if(translatedItem == null || translatedItem == key){
      translatedItem = this.translationPipe.transform(key.toUpperCase(),this.translationRequest);
    }    
    return translatedItem;
  } 

  submitPto() {
    this.formGroup.markAllAsTouched();

    if (this.formGroup.valid) {
      const ptoData = {
        Lob: this.claim.lob,
        ClaimId: this.claim.claimId,
        FileNumber: this.claim.claimNumber,
        UserOwns: this.claim.userOwns,
        NoteType: 'PTO',
        PtoDays: this.formGroup.controls.days.value,
        Source: this.claim.source,
        WorkSchedule: {
          IntakeWorkWeeks: [
            {
              WeekNumber: 0,
              DaysWorked: 0,
              IntakeDays: [
                {
                  DayOfWeek: 0,
                  Minutes: 0,
                  Hours: 0,
                  FormattedHours: '',
                  McfNumber: '',
                },
              ],
            },
          ],
        },
      };

      if (
        this.session.user.emulatorContext &&
        this.session.user.emulatorContext.isEmulating
      ) {
        this.snackBarService.show(
          this.translationPipe.transform('Preview-only mode. Information not sent.',this.translationRequest),
          SnackbarType.Info
        );
      } else {
        this.wsService.updateWeeklyWorkSchedule(ptoData).then(() => {
          this.isDisplaySuccess = true;
          this.formGroup.reset();
        });
      }
    }
  }
  private emptyData(): any {
    return null;
  }
  closePTO() {
    this.formGroup.reset();
    this.editPtoDialog.close();
  }
  _exportData() {
    
     const modifiedData = this.Ptos.ptoInformation.map((item) => {
        const formattedItem: any = { ...item };
        if (formattedItem?.ptoEffective) {
          formattedItem.ptoEffective = this.formatPipe.transform(formattedItem.ptoEffective, 'date');
        }
        if (formattedItem?.ptoExpire) {
          formattedItem.ptoExpire = this.formatPipe.transform(formattedItem.ptoExpire, 'date');
        }
         if (formattedItem?.periodStart) {
          formattedItem.periodStart = this.formatPipe.transform(formattedItem.periodStart, 'date');
        }
        if (formattedItem?.periodEnd) {
          formattedItem.periodEnd = this.formatPipe.transform(formattedItem.periodEnd, 'date');
        }
        if (formattedItem?.ptoType) {
          formattedItem.ptoType = this.translationPipe.transform(formattedItem.ptoType,this.translationRequest);
        }

        return formattedItem;
      });

    const csvParams = new CsvParams();
    csvParams.fileName = 'PTO';
    csvParams.rows = modifiedData;
    csvParams.keys = [
      'ptoEffective',
      'ptoExpire',
      'periodStart',
      'periodEnd',
      'initialBalance',
      'wpPtoApplied',
      'unpaidPtoApplied',
      'ptoBalance',
      'ptoType',
    ];
    csvParams.headers = [
      this.translationPipe.transform('PTO EFFECTIVE',this.translationRequest),
      this.translationPipe.transform('PTO EXPIRE',this.translationRequest),
      this.translationPipe.transform('PAY CYCLE START DATE',this.translationRequest),
      this.translationPipe.transform('PAY CYCLE END DATE',this.translationRequest),
      this.translationPipe.transform('INITIAL BALANCE',this.translationRequest),
      this.translationPipe.transform('WP PTO APPLIED',this.translationRequest),
      this.translationPipe.transform('UN PAID PTO APPLIED',this.translationRequest),
      this.translationPipe.transform('PTO BALANCE',this.translationRequest),
      this.translationPipe.transform('PTO TYPE',this.translationRequest),
    ];
    csvParams.headerNote = [];
    csvParams.headerNote.push(
     this.inpageAliasService.getTransformedValue(this.employeeAlias) + this.translationPipe.transform(' PTO reported on',this.translationRequest) +' : '+ this.reportedDate
    );
    csvParams.headerNote.push(this.translationPipe.transform('PTO days reported',this.translationRequest) +' : '+ this.daysReported);
    csvParams.headerNote.push(this.translationPipe.transform('PTO time available',this.translationRequest) +' : '+ this.availablePTO);

    this.csvService.download(csvParams);
  }
}
